<template lang="html">
  <v-text-field
    class="text-filed"
    v-model="internalValue"
    :label="label"
    :disabled="disabled"
    :rules="rules || []"
    :placeholder="placeholder || ' '"
    :type="type"
    outlined
    dense/>
</template>

<script>
export default {
  name: 'TextField',
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
      required: false,
    },
  },
  watch: {
    internalValue: {
      handler() {
        this.$emit('valueChanged', this.internalValue);
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
